import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms'

import { clearState, invokeInvoiceResponse, invokePaymentSession, setPaymentToken } from '../../store/payment.action';
import { selectInvoiceresponse, selectPaymentStateEvents } from '../../store/payment.selector';
import { InvoiceResponse, PaymentStateEvents } from '../../store/payment.state';
import { CardSkeletalComponent } from '../card-skeletal/card-skeletal.component';


@Component({
  selector: 'app-text-to-pay',
  imports: [CommonModule, ReactiveFormsModule, CardSkeletalComponent],
  templateUrl: './text-to-pay.component.html'
})
export class TextToPayComponent {
  private subscriptions$ = new Subscription();
  paymentToken: string = '';
  invoiceResponse!: InvoiceResponse;
  isLoading: boolean = true;
  isExpired: boolean = false;

  selectInvoiceresponse$;
  selectPaymentStateEvents$;

 

  constructor(private store: Store, private route: ActivatedRoute,
     @Inject(PLATFORM_ID) private platformId: any, private router: Router
  ) {
    this.selectInvoiceresponse$ = this.store.select(selectInvoiceresponse);
    this.selectPaymentStateEvents$ = this.store.select(selectPaymentStateEvents);
    this.subscriptions$.add(this.route.paramMap.subscribe((params: ParamMap) => this.setRouteParams(params)));
  }

  ngOnInit() {
    this.subscriptions$.add(this.selectInvoiceresponse$.subscribe((data: InvoiceResponse) => this.bindSelectInvoiceResponse(data)));
    this.subscriptions$.add(this.selectPaymentStateEvents$.subscribe((data: PaymentStateEvents) => this.bindSelectPaymentStateEvents(data)));
  }

  private setRouteParams(params: ParamMap): void {
    const queryParams = this.route.snapshot.queryParamMap;
    this.paymentToken = queryParams.get('s') || '';
    if (this.paymentToken) {
      this.store.dispatch(clearState());
      this.store.dispatch(setPaymentToken({ encodedString: this.paymentToken }));
      this.dispatch();
    }
  }

  dispatch() {
    this.store.dispatch(invokeInvoiceResponse({ encodedString: this.paymentToken }));
  }

  private bindSelectInvoiceResponse(data: InvoiceResponse): void {
    if (data) {
      this.invoiceResponse = data;
      if (this.invoiceResponse && this.invoiceResponse.dueAmount) {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('practiceId', this.invoiceResponse.practiceId.toString());
          localStorage.setItem('practiceGuid', this.invoiceResponse.practiceGuid);
        }
        this.store.dispatch(invokePaymentSession({ encodedString: this.paymentToken }));
        if (this.invoiceResponse.dueAmount > 0) {
          this.router.navigate(['/paynow']);
        }
      }
      else if (this.invoiceResponse.patientName && !this.invoiceResponse.dueAmount) {
        this.isExpired = true;
      }
    }
  }

  private bindSelectPaymentStateEvents(data: PaymentStateEvents): void {
    this.isLoading = data.loading;
  }

  ngOndestroy() {
    this.subscriptions$.unsubscribe();
  }
}

